<div class="page-content">

  <!-- HEADER -->
  <div class="page_header">
    <div class="page_header_text">
      <h1>Novo Contrato</h1>
      <span>Crie um novo contrato de prestação de serviços</span>
    </div>
    <div class="page_header_actions">
      <button class="btn-web-secondary" (click)="cancelar()">
        <i class="fas fa-arrow-left"></i> Voltar
      </button>
      <button class="btn-web-primary" (click)="save()" [disabled]="saving">
        <i [class]="saving ? 'fas fa-spinner fa-spin' : 'ri-save-2-line'"></i>
        {{ saving ? "A guardar..." : "Guardar Contrato" }}
      </button>
    </div>
  </div>

  <form [formGroup]="form">
    <!-- ── CARD 1: CLIENTE ────────────────────────────────────────── -->
    <div class="form-card">
      <div class="fc-header"><i class="fas fa-building"></i> Cliente</div>
      <div class="fc-body">
        <!-- Banner when client is pre-selected -->
        <div class="cliente-fixo-banner" *ngIf="clienteFixo">
          <i class="ri-information-line"></i>
          <span
            >A criar contrato para
            <strong>{{ clienteFixo.nome }}</strong>
            <ng-container *ngIf="clienteFixo.nif">
              · NIF: {{ clienteFixo.nif }}</ng-container
            >
          </span>
        </div>

        <!-- Dropdown when free selection -->
        <div class="form-group" *ngIf="!clienteFixo">
          <label>Seleccionar Cliente <span class="req">*</span></label>
          <p-select
            formControlName="idCliente"
            [options]="clientes"
            [optionLabel]="'nome'"
            optionValue="id"
            placeholder="Escolha um cliente..."
            [showClear]="true"
            [filter]="true"
            filterBy="nome,nif"
            styleClass="w-full"
            appendTo="body"
          >
            <ng-template pTemplate="selectedItem" let-c>
              <span *ngIf="c"
                >{{ c.nome
                }}<span class="opt-nif" *ngIf="c.nif">
                  · {{ c.nif }}</span
                ></span
              >
            </ng-template>
            <ng-template pTemplate="item" let-c>
              <div class="opt-row">
                <span class="opt-nome">{{ c.nome }}</span>
                <span class="opt-nif" *ngIf="c.nif">{{ c.nif }}</span>
              </div>
            </ng-template>
          </p-select>
          <span
            class="sp-error"
            *ngIf="
              form.get('idCliente')?.invalid && form.get('idCliente')?.touched
            "
          >
            Seleccione um cliente
          </span>
        </div>
      </div>
    </div>

    <!-- ── CARD 2: CONDIÇÕES CONTRATUAIS ─────────────────────────── -->
    <div class="form-card">
      <div class="fc-header">
        <i class="fas fa-coins"></i> Condições Contratuais
      </div>
      <div class="fc-body">
        <div class="form-grid-2">
          <div class="form-group">
            <label>Valor Mensal (Kz) <span class="req">*</span></label>
            <div class="kz-wrap">
              <span class="kz-prefix">Kz</span>
              <p-inputNumber
                formControlName="valorMensal"
                [min]="0"
                [useGrouping]="true"
                placeholder="0"
                styleClass="w-full sp-inputnumber kz-input"
              >
              </p-inputNumber>
            </div>
            <span
              class="sp-error"
              *ngIf="
                form.get('valorMensal')?.invalid &&
                form.get('valorMensal')?.touched
              "
            >
              Campo obrigatório
            </span>
          </div>
          <div class="form-group">
            <label>Nº de Postos</label>
            <p-inputNumber
              formControlName="numPostos"
              [min]="1"
              styleClass="w-full form-inputnumber"
            >
            </p-inputNumber>
          </div>
        </div>

        <!-- Financial summary -->
        <div
          class="finance-card"
          *ngIf="(form.get('valorMensal')?.value || 0) > 0"
        >
          <div class="fc-summary-row">
            <i class="fas fa-dollar-sign fcs-icon"></i>
            <span class="fcs-title">Resumo Financeiro</span>
          </div>
          <div class="fcs-body">
            <div class="fcs-item">
              <span class="fcs-lbl">Valor Mensal</span>
              <span class="fcs-val">{{
                fmtKz(form.get("valorMensal")?.value)
              }}</span>
            </div>
            <div class="fcs-item">
              <span class="fcs-lbl">Valor Anual estimado</span>
              <span class="fcs-val primary">{{ fmtKz(valorAnual) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── CARD 3: PERÍODO DO CONTRATO ───────────────────────────── -->
    <div class="form-card">
      <div class="fc-header">
        <i class="fas fa-calendar-alt"></i> Período do Contrato
      </div>
      <div class="fc-body">
        <div class="form-grid-3">
          <div class="form-group">
            <label>Data de Início <span class="req">*</span></label>
            <p-datepicker [showIcon]="true"
              formControlName="inicioContrato"
              dateFormat="dd/mm/yy"
              placeholder="dd/mm/aaaa"
              styleClass="w-full"
              appendTo="body"
            >
            </p-datepicker>
            <span
              class="sp-error"
              *ngIf="
                form.get('inicioContrato')?.invalid &&
                form.get('inicioContrato')?.touched
              "
            >
              Campo obrigatório
            </span>
          </div>
          <div class="form-group">
            <label>Data de Fim <span class="req">*</span></label>
            <p-datepicker [showIcon]="true"
              formControlName="fimContrato"
              dateFormat="dd/mm/yy"
              placeholder="dd/mm/aaaa"
              styleClass="w-full"
              appendTo="body"
            >
            </p-datepicker>
            <span
              class="sp-error"
              *ngIf="
                form.get('fimContrato')?.invalid &&
                form.get('fimContrato')?.touched
              "
            >
              Campo obrigatório
            </span>
          </div>
          <div class="form-group">
            <label>Data de Facturação</label>
            <p-datepicker [showIcon]="true"
              formControlName="dataFaturacao"
              dateFormat="dd/mm/yy"
              placeholder="dd/mm/aaaa"
              styleClass="w-full"
              appendTo="body"
            >
            </p-datepicker>
          </div>
        </div>

        <div class="duracao-pill" *ngIf="duracaoMeses > 0">
          <i class="fas fa-calendar-check"></i>
          Duração:
          <strong
            >{{ duracaoMeses }} mes{{ duracaoMeses !== 1 ? "es" : "" }}</strong
          >
        </div>
      </div>
    </div>

    <!-- ── CARD 4: OBSERVAÇÕES ───────────────────────────────────── -->
    <div class="form-card">
      <div class="fc-header">
        <i class="ri-sticky-note-2-line"></i> Observações
        <span class="fc-opt">opcional</span>
      </div>
      <div class="fc-body">
        <div class="form-group">
          <label>Notas adicionais sobre o contrato</label>
          <textarea
            class="sp-input sp-textarea"
            formControlName="observacoes"
            rows="4"
            placeholder="Condições especiais, cláusulas adicionais..."
          ></textarea>
        </div>
      </div>
    </div>
  </form>

  <!-- Footer actions -->
  <div class="form-actions">
    <button type="button" class="btn-web-secondary" (click)="cancelar()">
      Cancelar
    </button>
    <button
      type="button"
      class="btn-web-primary"
      (click)="save()"
      [disabled]="saving"
    >
      <i [class]="saving ? 'fas fa-spinner fa-spin' : 'ri-save-2-line'"></i>
      {{ saving ? "A guardar..." : "Guardar Contrato" }}
    </button>
  </div>
</div>

